export enum StoreDisplayMode {
  HIDE = "hide",
  SHOW = "show",
  SHOW_LOGGED_IN = "show_logged_in"
}
